import {
  Table,
  TableContainer,
  TableHead,
  TableCell,
  TableRow,
  TableBody,
  Typography,
  Grid,
  CircularProgress,
  Skeleton,
  TextField,
  InputAdornment,
} from "@mui/material";
import { Box } from "@mui/system";
// import { FiCurveInputPercent } from "../../inputs/inputs";
import formatter from "../../tools/formatter";
import moment from "moment";

export default function TripleABenchmark({
  taxRate,
  setTaxRate,
  data,
  referenceDate,
  loading,
}) {

  function onTaxChange(value) {
    setTaxRate(value.replace(/[^0-9.]/g, ''))
  }

  return (
    <Box>
      <Typography textAlign="center">
        Spline Data AAA
      </Typography>
      <Box
        display="flex"
        justifyContent="center"
        borderBottom="solid 1px #000"
        pb={1}
        mb={1}
      >
        {loading ? (
          <Skeleton variant="text" width={100} />
        ) : (
          <Typography textAlign="center" variant="subtitle2">
            ({moment(referenceDate).format("MM/DD/YYYY")})
          </Typography>
        )}
      </Box>
      {loading ? (
        <Box textAlign="center">
          <CircularProgress />
        </Box>
      ) : (
        <>
          <TableContainer component={Box} marginBottom={2}>
            <Table stickyHeader size="small">
              <TableHead>
                <TableRow>
                  <TableCell align="center">Maturity</TableCell>
                  <TableCell align="center">Yield</TableCell>
                  <TableCell align="center">YTM</TableCell>
                  <TableCell align="center">Tax-Equiv</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {Object.keys(data)?.map((maturity) => (
                  <TableRow key={maturity}>
                    <TableCell align="center">{maturity}</TableCell>
                    <TableCell align="center">
                      {formatter.percent(data?.[maturity]?.yield)}
                    </TableCell>
                    <TableCell align="center">
                      {formatter.percent(data?.[maturity]?.fiCurveYTM)}
                    </TableCell>
                    <TableCell align="center">
                      {formatter.percent(data?.[maturity]?.fiCurveTaxEquiv)}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <Grid container alignItems="center" spacing={1}>
            <Grid item>
              <Typography width="100%">Tax Rate:</Typography>
            </Grid>
            <Grid item> 
              <TextField
                size="small"
                value={taxRate}
                onChange={(e) => onTaxChange(e.target.value)}
                slotProps={{
                  input: {
                    endAdornment: <InputAdornment position="start">%</InputAdornment>,
                  }
                }}
              />
            </Grid>
          </Grid>
        </>
      )}
    </Box>
  );
}
